<template>
  <div class="lanesViewer">

    <div class="laneTitle">
      <div style="display: inline; float: left;">
        <figure>
          <img class="logo" :src="`${publicPath}img/Axes2-text-logo-sm.png`"/>
        </figure>
      </div>
      <div style="display: inline; float: right;">
        <div>
          <select id="location" v-model="selected_lane_id" class="location" @change="notifyLaneChange">
            <option disabled value="">Select a location</option>
            <option v-for="location in locations" :key="location.id" :value="location.id">
              {{ location.name }}
            </option>
          </select>
        </div>
        <div>
          <p style="font-family: arial;">www.axes<sup>2</sup>.ca</p>
        </div>
      </div>
    </div>

    <div class="laneViewer">
      <div v-if="this.display_data == null">
        <div class="has-text-centered">
          <br/>
          <br/>
          <img :src="`${publicPath}img/fire.webp`" class="wait_logo"/>
          <br/>
          <br/>
        </div>
      </div>
      <div v-if="this.display_data != null" :key="this.componentKey">
        <div v-if="this.display_data.control_type === 'new_game'">
          <h1>New Round-Robin</h1>
          <ul v-for="(player, index) in this.display_data.control_value.players" :key="index">
            <li>{{ player.name }}</li>
          </ul>
        </div>
        <!-- match winner -->
        <!--
        <div v-if="this.display_data.control_type === 'match' && this.display_data.control_value.match.completed == true">
          <h1>Match Winner:</h1>
          <div v-if="this.display_data.control_value.match.matchPlayers[0].winner">
            <p> {{ this.display_data.control_value.match.matchPlayers[0].player.name }}</p>
          </div>
          <div v-if="this.display_data.control_value.match.matchPlayers[1].winner">
            <p> {{ this.display_data.control_value.match.matchPlayers[1].player.name }}</p>
          </div>
        </div>
        -->
        <!-- match -->
        <div v-if="this.display_data.control_type === 'match'">
          <!--
            match has potential titles of 'Match Completed', 'Match', 'New Match'
          -->
          <br/>
          <br/>
          <h1 class="is-size-1  has-text-centered match_title">{{ display_data.control_value.match.title }}</h1>
          <div class="columns is-mobile">
            <div class="column has-text-centered">
              <div class="player_name">
                {{ this.getLeftPlayerName }}
              </div>
              <div class="player_throws">
                <span v-for="thrw in this.getLeftPlayerThrows">
                  <span class="thrw" v-bind:style="[ thrw == 5 ? {'color': 'yellow'} : {'color': 'white'}]">{{  thrw  }}</span>
                </span>
              </div>
              <div class="big_number">
                {{ this.calculateLeftTotal }}
              </div>              
            </div>
            <div class="column has-text-centered">
              <div class="player_name">
                {{ this.getRightPlayerName }}
              </div>
              <div class="player_throws">
                <span v-for="thrw in this.getRightPlayerThrows">
                  <span class="thrw" v-bind:style="[ thrw == 5 ? {'color': 'yellow'} : {'color': 'white'}]">{{  thrw  }}</span>
                </span>
              </div>
              <div class="big_number">
                {{ this.calculateRightTotal }}
              </div>              
            </div>
          </div>
        </div>

        <div class="footer" v-if="this.getNextUp != null && this.getNextUp != ''">
          <span class="is-size-4">Next Up: {{ this.getNextUp }}</span>
        </div>
        <!--
        <div v-for="(game, index) in broadcast_control" :key="index">
          <div class="displayItem">
            <p>{{ game.title }}</p>
            <ul>
              <li>game.control_type: {{ game.control_type  }}</li>
              <li>game.control_value.league: {{ game.control_value.league }}</li>
              <li>game.control_value.title: {{ game.control_value.title }}</li>
              <li>game.control_value.uniqueId: {{ game.control_value.uniqueId }}</li>
              <li>game.control_value.uniqueItemId: {{ game.control_value.uniqueItemId }}</li>
              <li>game.control_value.match: {{ game.control_value.match }}</li>
            </ul>
          </div>
        </div>
        -->
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import SocketioService from '../services/socketio.service.js';

export default {
  name: 'lanesViewer',
    props: {
      lane_id: null
    },
    components : {
    },
    computed: {
      getNextUp() {
        var nextUp = this.display_data.control_value.nextUp;
        return nextUp;
      },
      getLeftPlayerName() {
        var match = this.display_data.control_value.match;
        return match?.matchPlayers[0].player.name;
      },
      getLeftPlayerThrows() {
        var throws = [];
        for (var i = 0 ; i< this.display_data.control_value.match.matchPlayers[0].throws.length; i++) {
          throws.push(this.display_data.control_value.match.matchPlayers[0].throws[i].basicScore);
        }
        return throws;
      },
      getRightPlayerName() {
        var match = this.display_data.control_value.match;
        return match?.matchPlayers[1].player.name;
      },
      getRightPlayerThrows() {
        var throws = [];
        for (var i = 0 ; i< this.display_data.control_value.match.matchPlayers[1].throws.length; i++) {
          throws.push(this.display_data.control_value.match.matchPlayers[1].throws[i].basicScore);
        }
        return throws;
      },
      calculateLeftTotal() {
        var match = this.display_data.control_value.match;
        var total = 0;
        for (var i = 0 ; i< match.matchPlayers[0].throws.length; i++) {
          total += match.matchPlayers[0].throws[i].basicScore;
        }
      return total;
    },
    calculateRightTotal() {
        var match = this.display_data.control_value.match;
        var total = 0;
        for (var i = 0 ; i< match.matchPlayers[1].throws.length; i++) {
          total += match.matchPlayers[1].throws[i].basicScore;
        }
        return total;
      }
    },
    created() {
      //console.log("SocketioService.setupSocketConnection()");
      //SocketioService.setupSocketConnection();
    },
    beforeUnmount() {
      //console.log("SocketioService.disconnect()");
      //SocketioService.disconnect();
    },
    data () {
      return {
        location: '',
        locations: [ // Example locations array
          { id: 'D1', name: "Dartmouth 1" },
          { id: 'D2', name: "Dartmouth 2" },
          { id: 'M1', name: "Moncton 1" },
          { id: 'M2', name: "Moncton 2" },
          { id: 'M3', name: "Moncton 3" },
          { id: 'T1', name: "Testing 1" },
          { id: 'T2', name: "Testing 2" }
        ],
        debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
        publicPath: process.env.BASE_URL,
        broadcast_control: [],
        display_data: null,
        component_key: 0,
        please_wait: false,
        selected_lane_id: null /*,
        timeout: new Date().toISOString()*/
      }
    },
    methods:{
      notifyLaneChange(newLaneId) {
        //this.selected_lane_id = newLaneId; // Update the parent value when the child emits
        this.display_data = null;
      },
      /*
      hasElapsed(timeout) {
        const timeoutTime = new Date(timeout).getTime(); // Convert timeout to milliseconds
        const currentTime = Date.now(); // Get current time in milliseconds
        const elapsedTime = (currentTime - timeoutTime) / 1000; // Calculate elapsed time in seconds
        //console.log("elapsedTime", elapsedTime);
        return elapsedTime > 600; // Check if more than 600 seconds have elapsed
      },*/
      getBroadcastControlRequests() {
        var items = SocketioService.items;
        SocketioService.items = [];
        //console.log("getBroadcastControlRequests()", items);
        if (items != null && items.length > 0) {
          this.addItemsToBroadcastControl(items);
          //this.timeout = new Date().toISOString(); 
        } 
        /*
        if (this.hasElapsed(this.timeout)) {
          this.display_data = null;
          this.timeout = new Date().toISOString(); 
          //console.log("---time has elapsed.")
        } else {
          //console.log("time hasn't elapsed.")
        }
        */
      },
      splitLastGroup(str) {
        // Split the string at the space character
        str = str.replace("Finals_", "");
        const parts = str.split(' ');
        // Get the last part of the split string
        const lastPart = parts[parts.length - 1];
        // Split the last part at the underscore
        const resultArray = lastPart.split('_');
        return resultArray;
      },
      buildMatchDisplayTitle(item) {
        const matchTitleArr = this.splitLastGroup(item.control_value.match.id);
        var finals = (item.control_value.match.id.indexOf("Finals") != -1 ? true : false);
        var title = (finals? "Finals " : "") + "Round " + matchTitleArr[[0]] + " Match " + matchTitleArr[1];
        return title;
      },
      addItemsToBroadcastControl(items) {
        //console.log("addItemsToBroadcastControl");
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          //console.log("item", item);

          /*

          throttle updates so that completed matches have time to display the winner.

          */

          //console.log("compare", "item lane:" + item.control_value.lane_id, "this.lane_id: " + this.lane_id);
          if (item.control_value.lane_id === this.selected_lane_id) {
            if (item.control_type === 'match') {
              var title = this.buildMatchDisplayTitle(item);
              //console.log("title", title);
              item.control_value.match.title = title;
              //console.log("display_data",item);
              this.display_data = item;
              this.componentKey++;
            }

          }
        }
      }
    },
    mounted(){
      console.log("Lane ", this.lane_id);
      this.selected_lane_id = this.lane_id;
      setInterval(() => {
        this.getBroadcastControlRequests();
      }, 2000);      
    }
}
</script>

<style lang="scss" scoped>
.lanesViewer {
  background-color: black;
  color: white;
  padding: 30px;
}
.laneTitle {
  background-color: black;
  color: whote;
  top: 0px;
  right: 0px;
  position: absolute;
  z-Index: 1000;
  width: 100%;
  padding-top: 40px;
  padding-left: 40px;
  padding-right: 40px;
}
.match_title {
  font-family: arial;
  font-size: 2em;
  color: gray;
}
.footer {
  font-family: arial;
  font-size: 2em;
  position: fixed;
  bottom: 50px;
  left: 0;
  width: 100%;
  background-color: black;
  color: gray;
  text-align: center;
  padding: 10px;
}

.laneViewer {
  
}
.logo {
    width: 125px;
}
.displayItem {
  padding: 10px; 
  margin: 10px; 
  border: solid gray 1px;
  font-family: 'Courier';
  font-size: 0.8em;
}
.big_number {
  font-size: 25em;
  padding-top: 0px;
  margin-top: 0px;
}
.player_name {
  font-size: 5em;
}
.thrw {
  font-size: 4em;
  display: inline;
  border: solid white 1px;
  padding: 5px;
  margin-left: 5px;
}
.location {
  color: yellow;
  background-color: black;
}

@keyframes rotateLogo {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.wait_logo {
  width: 30%;
  /*
  animation: rotateLogo 10s linear infinite;
  display: inline-block;
  */
}

</style>